export function handlePublishForm(publish: () => void) {
  publish();
}
